import { Injectable, Signal, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { GsStructBlock, GsStructPage } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class PageService {
  public pageChange: Subject<GsStructPage | undefined> = new Subject<GsStructPage | undefined>();

  /** The currently open page loaded from the backend */
  private readonly _page = signal<GsStructPage | undefined>(undefined);
  // Getters & Setters
  /** Getter for the page-data */
  get pageSignal(): Signal<GsStructPage | undefined> {
    return this._page.asReadonly();
  }
  get page(): GsStructPage | undefined {
    return this._page();
  }
  /** Setter for the page */
  set page(value: GsStructPage | undefined) {
    this._page.set(value);
    this.pageChange.next(value);
  }

  // Methods
  /**
   * Gets the block containing the component with the given clientId
   * @param clientId clientId of the component to search for
   * @returns the full block the component is in
   */
  getBlockByComponent(clientId: string): GsStructBlock | undefined {
    const blockData = this.page?.blocks?.find((block) => block.components?.some((component) => component.clientId === clientId));
    if (blockData) {
      const blockWithoutComponents = { ...blockData, components: undefined };
      return blockWithoutComponents;
    }
    return undefined;
  }
}
